import { render, staticRenderFns } from "./YKTransactions.vue?vue&type=template&id=30fefa45&"
import script from "./YKTransactions.vue?vue&type=script&lang=js&"
export * from "./YKTransactions.vue?vue&type=script&lang=js&"
import style0 from "./YKTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports